export default["__VITE_ASSET__2PAkeK2q__","__VITE_ASSET__8EPkINas__"];